import "./styles.css";

function WaveBackground() {
  return (
    <div className="wave-background-container">
      <div className="wave-background" />
    </div>
  );
}
export default WaveBackground;
